import i18n from '../i18n';

/** Id видов спорта с HasDemoSchool в БД (не 1..5 подряд). */
export function getFallbackDemoCatalog() {
  return [
    {
      sportTypeId: 1,
      name: i18n.t('demoCatalog:hockeySchool'),
      sport: i18n.t('demoCatalog:hockeySport'),
      sportEmoji: '🏒',
      city: i18n.t('demoCatalog:hockeyCity')
    },
    {
      sportTypeId: 7,
      name: i18n.t('demoCatalog:swimmingSchool'),
      sport: i18n.t('demoCatalog:swimmingSport'),
      sportEmoji: '🏊',
      city: i18n.t('demoCatalog:swimmingCity')
    },
    {
      sportTypeId: 13,
      name: i18n.t('demoCatalog:footballSchool'),
      sport: i18n.t('demoCatalog:footballSport'),
      sportEmoji: '⚽',
      city: i18n.t('demoCatalog:footballCity')
    },
    {
      sportTypeId: 20,
      name: i18n.t('demoCatalog:boxingSchool'),
      sport: i18n.t('demoCatalog:boxingSport'),
      sportEmoji: '🥊',
      city: i18n.t('demoCatalog:boxingCity')
    },
    {
      sportTypeId: 32,
      name: i18n.t('demoCatalog:gymnasticsSchool'),
      sport: i18n.t('demoCatalog:gymnasticsSport'),
      sportEmoji: '🎗',
      city: i18n.t('demoCatalog:gymnasticsCity')
    }
  ];
}

/** @deprecated Use getFallbackDemoCatalog() — static export does not update on locale change. */
export const FALLBACK_DEMO_CATALOG = getFallbackDemoCatalog();

export function parseCatalogResponse(data) {
  if (typeof data === 'string') {
    if (data.trimStart().startsWith('<')) return [];
    try {
      return parseCatalogResponse(JSON.parse(data));
    } catch {
      return [];
    }
  }
  if (!Array.isArray(data)) return [];
  const seen = new Set();
  return data.filter((x) => {
    const id = x?.sportTypeId ?? x?.SportTypeId;
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

export function parseListResponse(data) {
  if (!Array.isArray(data)) return [];
  return data;
}
